import { render, staticRenderFns } from "./CardTile.vue?vue&type=template&id=23aa35b2&scoped=true&"
import script from "./CardTile.vue?vue&type=script&lang=js&"
export * from "./CardTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa35b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VSpacer,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23aa35b2')) {
      api.createRecord('23aa35b2', component.options)
    } else {
      api.reload('23aa35b2', component.options)
    }
    module.hot.accept("./CardTile.vue?vue&type=template&id=23aa35b2&scoped=true&", function () {
      api.rerender('23aa35b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/program/components/Dashboard/CardTile.vue"
export default component.exports